// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.main_cont .ps-sidebar-root .left_panel_partts {
  width: 100%;
  height: 100%;
  padding: 0;
}
.main_cont .ps-sidebar-root {
  background: #004aad;
  /* max-width: 20%;
    width: 100%; */
  position: relative;
  flex: 1 1;
  flex: 0 0 20%;
  min-height: calc(100vh - 51px);
  padding: 0 20px;
  border-radius: 0 10px 10px 0;
  width: 100%;
  min-width: auto;
}

.main_cont .ps-sidebar-container {
  width: 100%;
  height: 100%;
  background-color: transparent;
  overflow: visible;
}

.main_cont .ps-sidebar-container .ps-menu-button {
  padding-left: 0;
  padding-right: 0;
  height: auto;
}

.main_cont .ps-sidebar-container .ps-menu-button:hover,
.main_cont .ps-sidebar-container .ps-menu-button:focus {
  background: transparent;
}
.main_cont .ps-sidebar-container .ps-submenu-content {
  background: transparent;
  padding-left: 40px;
}

.main_cont .ps-sidebar-container .ps-submenu-content ul {
  padding: 2px 0;
}
.left_panel_partts ul {
  margin: 0px;
  padding-left: 0px;
  padding: 30px 0;
}
.left_panel_partts ul li {
  list-style: none;
}
.left_panel_partts ul li a {
  color: #fff !important;
  font-weight: 400;
  font-size: 16px;
  text-decoration: none;
  display: flex;
  align-items: center;
}
.left_panel_partts ul li {
  padding: 12px 0;
  width: 100%;
}
.dasg__imgg img {
  width: 25px;
}
.ps-menu-icon img {
  width: 25px;
}
.dasg__imgg {
  display: inline-block;
  width: 35px;
}
.ps-submenu-expand-icon span {
  width: 10px;
  height: 10px;
  border-right-width: 4px;
  border-bottom-width: 4px;
}

.ps-submenu-root .ps-submenu-expand-icon span {
  position: relative;
  border: 0px;
  transform: none;
}

.ps-submenu-root .ps-submenu-expand-icon span:after {
  content: "+";
  position: absolute;
  right: 0;
  font-size: 24px;
  color: #fff;
  top: -13px;
  transform: none;
}

.ps-menuitem-root .ps-submenu-root.ps-menuitem-root .ps-submenu-expand-icon span:after {
  content: "+";
  position: absolute;
  right: 0;
  font-size: 24px;
  color: #fff;
  top: -13px;
  transform: none;
}

.ps-submenu-root.ps-open .ps-submenu-expand-icon span:after {
  content: "-";
  font-size: 34px;
  top: -26px;
}
.ps-menuitem-root .ps-submenu-root.ps-menuitem-root .ps-menu-button.ps-open .ps-submenu-expand-icon span:after {
  content: "-";
  font-size: 34px;
  top: -26px;
}
.ps-sidebar-root .ps-menu-icon {
  width: 25px;
  min-width: 25px;
  line-height: 25px;
  height: auto;
}

.modal_close h3 {
  text-align: center;
  font-size: 24px;
  font-weight: 600;
  color: #000;
}

.modal_close .close_buuut {
  width: 25px;
  height: 25px;
  text-align: center;
  padding: 0px;
  border: 0px;
  background: #f00;
  position: absolute;
  right: -15px;
  top: -15px;
  line-height: 25px;
  border-radius: 100%;
}
.modal_close .close_buuut:after {
  content: "X";
  color: #fff;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}

.footer_but {
  display: flex;
  justify-content: center;
  align-items: center;
}

.yesbut {
  padding: 0 30px;
  height: 40px;
  line-height: 40px;
  color: #fff;
  font-weight: 600;
  background: #0571b9;
  font-size: 18px;
  text-transform: uppercase;
  margin: 0 10px;
  border: 0px;
}

.nobut {
  padding: 0 30px;
  height: 40px;
  line-height: 40px;
  color: #fff;
  font-weight: 600;
  background: #f00;
  font-size: 18px;
  text-transform: uppercase;
  margin: 0 10px;
  border: 0px;
}

.popuptext h3 {
  font-size: 22px;
  text-align: center;
  margin-bottom: 25px;
}
.popuptext p {
  font-size: 16px;
  color: #000;
  font-weight: 400;
  line-height: 24px;
}

.close_button {
  position: absolute;
  width: 30px;
  height: 30px;
  background: #f00;
  border-radius: 100%;
  right: -10px;
  top: -20px;
}
.close_button:after {
  content: "X";
  position: absolute;
  left: 50%;
  top: 50%;
  color: #fff;
  transform: translate(-50%, -50%);
}

.modal_t_field {
  height: 45px;
  border-color: #004aad;
}

.modal_t_area {
  border-color: #004aad;
}

.modal_submit {
  text-align: center;
}
.modal_submit .sub_but {
  background: #004aad;
  border: 0px;
  padding: 10px 40px;
  color: #fff;
  font-size: 16px;
  font-weight: 600;
}

.popuptext h3 {
  font-size: 22px;
  text-align: center;
  margin-bottom: 25px;
}
.popuptext p {
  font-size: 16px;
  color: #000;
  font-weight: 400;
  line-height: 24px;
}

.close_button {
  position: absolute;
  width: 30px;
  height: 30px;
  background: #f00;
  border-radius: 100%;
  right: -10px;
  top: -20px;
}
.close_button:after {
  content: "X";
  position: absolute;
  left: 50%;
  top: 50%;
  color: #fff;
  transform: translate(-50%, -50%);
}

.modal_t_field {
  height: 45px;
  border-color: #004aad;
}

.modal_t_area {
  border-color: #004aad;
}

.modal_submit {
  text-align: center;
}
.modal_submit .sub_but {
  background: #004aad;
  border: 0px;
  padding: 10px 40px;
  color: #fff;
  font-size: 16px;
  font-weight: 600;
}

.modal_t_field1 {
  height: 45px;
  border-color: #004aad;
}

.ps-menuitem-root
  .ps-submenu-root.ps-menuitem-root
  .ps-submenu-expand-icon
  span:after {
  content: "+";
  position: absolute;
  right: 0;
  font-size: 24px;
  color: #fff;
  top: -13px;
  transform: none;
}

.ps-menuitem-root
  .ps-submenu-root.ps-menuitem-root
  .ps-menu-button.ps-open
  .ps-submenu-expand-icon
  span:after {
  content: "-";
  font-size: 34px;
  top: -26px;
}

@media screen and (max-width: 1199px) {
  .main_cont .ps-sidebar-root {
    flex: 0 0 30%;
  }
}

@media screen and (max-width: 767px) {
  .main_cont .ps-sidebar-root {
    flex: 0 0 100%;
  }
}

@media screen and (max-width: 420px) {
  .left_panel_partts ul li a {
    font-size: 14px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/leftpanel/leftpanel-member.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,YAAY;EACZ,UAAU;AACZ;AACA;EACE,mBAAmB;EACnB;kBACgB;EAChB,kBAAkB;EAClB,SAAO;EACP,aAAa;EACb,8BAA8B;EAC9B,eAAe;EACf,4BAA4B;EAC5B,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,6BAA6B;EAC7B,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,YAAY;AACd;;AAEA;;EAEE,uBAAuB;AACzB;AACA;EACE,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;AACA;EACE,WAAW;EACX,iBAAiB;EACjB,eAAe;AACjB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,eAAe;EACf,qBAAqB;EACrB,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,WAAW;AACb;AACA;EACE,WAAW;AACb;AACA;EACE,WAAW;AACb;AACA;EACE,qBAAqB;EACrB,WAAW;AACb;AACA;EACE,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,QAAQ;EACR,eAAe;EACf,WAAW;EACX,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,QAAQ;EACR,eAAe;EACf,WAAW;EACX,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,UAAU;AACZ;AACA;EACE,YAAY;EACZ,eAAe;EACf,UAAU;AACZ;AACA;EACE,WAAW;EACX,eAAe;EACf,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;EACZ,UAAU;EACV,iBAAiB;EACjB,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,iBAAiB;EACjB,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,yBAAyB;EACzB,cAAc;EACd,WAAW;AACb;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,iBAAiB;EACjB,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,cAAc;EACd,WAAW;AACb;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,YAAY;EACZ,UAAU;AACZ;AACA;EACE,YAAY;EACZ,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,WAAW;EACX,gCAAgC;AAClC;;AAEA;EACE,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;AACpB;AACA;EACE,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,YAAY;EACZ,UAAU;AACZ;AACA;EACE,YAAY;EACZ,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,WAAW;EACX,gCAAgC;AAClC;;AAEA;EACE,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;AACpB;AACA;EACE,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,qBAAqB;AACvB;;AAEA;;;;EAIE,YAAY;EACZ,kBAAkB;EAClB,QAAQ;EACR,eAAe;EACf,WAAW;EACX,UAAU;EACV,eAAe;AACjB;;AAEA;;;;;EAKE,YAAY;EACZ,eAAe;EACf,UAAU;AACZ;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,cAAc;EAChB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;AACF","sourcesContent":[".main_cont .ps-sidebar-root .left_panel_partts {\n  width: 100%;\n  height: 100%;\n  padding: 0;\n}\n.main_cont .ps-sidebar-root {\n  background: #004aad;\n  /* max-width: 20%;\n    width: 100%; */\n  position: relative;\n  flex: 1;\n  flex: 0 0 20%;\n  min-height: calc(100vh - 51px);\n  padding: 0 20px;\n  border-radius: 0 10px 10px 0;\n  width: 100%;\n  min-width: auto;\n}\n\n.main_cont .ps-sidebar-container {\n  width: 100%;\n  height: 100%;\n  background-color: transparent;\n  overflow: visible;\n}\n\n.main_cont .ps-sidebar-container .ps-menu-button {\n  padding-left: 0;\n  padding-right: 0;\n  height: auto;\n}\n\n.main_cont .ps-sidebar-container .ps-menu-button:hover,\n.main_cont .ps-sidebar-container .ps-menu-button:focus {\n  background: transparent;\n}\n.main_cont .ps-sidebar-container .ps-submenu-content {\n  background: transparent;\n  padding-left: 40px;\n}\n\n.main_cont .ps-sidebar-container .ps-submenu-content ul {\n  padding: 2px 0;\n}\n.left_panel_partts ul {\n  margin: 0px;\n  padding-left: 0px;\n  padding: 30px 0;\n}\n.left_panel_partts ul li {\n  list-style: none;\n}\n.left_panel_partts ul li a {\n  color: #fff !important;\n  font-weight: 400;\n  font-size: 16px;\n  text-decoration: none;\n  display: flex;\n  align-items: center;\n}\n.left_panel_partts ul li {\n  padding: 12px 0;\n  width: 100%;\n}\n.dasg__imgg img {\n  width: 25px;\n}\n.ps-menu-icon img {\n  width: 25px;\n}\n.dasg__imgg {\n  display: inline-block;\n  width: 35px;\n}\n.ps-submenu-expand-icon span {\n  width: 10px;\n  height: 10px;\n  border-right-width: 4px;\n  border-bottom-width: 4px;\n}\n\n.ps-submenu-root .ps-submenu-expand-icon span {\n  position: relative;\n  border: 0px;\n  transform: none;\n}\n\n.ps-submenu-root .ps-submenu-expand-icon span:after {\n  content: \"+\";\n  position: absolute;\n  right: 0;\n  font-size: 24px;\n  color: #fff;\n  top: -13px;\n  transform: none;\n}\n\n.ps-menuitem-root .ps-submenu-root.ps-menuitem-root .ps-submenu-expand-icon span:after {\n  content: \"+\";\n  position: absolute;\n  right: 0;\n  font-size: 24px;\n  color: #fff;\n  top: -13px;\n  transform: none;\n}\n\n.ps-submenu-root.ps-open .ps-submenu-expand-icon span:after {\n  content: \"-\";\n  font-size: 34px;\n  top: -26px;\n}\n.ps-menuitem-root .ps-submenu-root.ps-menuitem-root .ps-menu-button.ps-open .ps-submenu-expand-icon span:after {\n  content: \"-\";\n  font-size: 34px;\n  top: -26px;\n}\n.ps-sidebar-root .ps-menu-icon {\n  width: 25px;\n  min-width: 25px;\n  line-height: 25px;\n  height: auto;\n}\n\n.modal_close h3 {\n  text-align: center;\n  font-size: 24px;\n  font-weight: 600;\n  color: #000;\n}\n\n.modal_close .close_buuut {\n  width: 25px;\n  height: 25px;\n  text-align: center;\n  padding: 0px;\n  border: 0px;\n  background: #f00;\n  position: absolute;\n  right: -15px;\n  top: -15px;\n  line-height: 25px;\n  border-radius: 100%;\n}\n.modal_close .close_buuut:after {\n  content: \"X\";\n  color: #fff;\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  transform: translate(-50%, -50%);\n}\n\n.footer_but {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.yesbut {\n  padding: 0 30px;\n  height: 40px;\n  line-height: 40px;\n  color: #fff;\n  font-weight: 600;\n  background: #0571b9;\n  font-size: 18px;\n  text-transform: uppercase;\n  margin: 0 10px;\n  border: 0px;\n}\n\n.nobut {\n  padding: 0 30px;\n  height: 40px;\n  line-height: 40px;\n  color: #fff;\n  font-weight: 600;\n  background: #f00;\n  font-size: 18px;\n  text-transform: uppercase;\n  margin: 0 10px;\n  border: 0px;\n}\n\n.popuptext h3 {\n  font-size: 22px;\n  text-align: center;\n  margin-bottom: 25px;\n}\n.popuptext p {\n  font-size: 16px;\n  color: #000;\n  font-weight: 400;\n  line-height: 24px;\n}\n\n.close_button {\n  position: absolute;\n  width: 30px;\n  height: 30px;\n  background: #f00;\n  border-radius: 100%;\n  right: -10px;\n  top: -20px;\n}\n.close_button:after {\n  content: \"X\";\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  color: #fff;\n  transform: translate(-50%, -50%);\n}\n\n.modal_t_field {\n  height: 45px;\n  border-color: #004aad;\n}\n\n.modal_t_area {\n  border-color: #004aad;\n}\n\n.modal_submit {\n  text-align: center;\n}\n.modal_submit .sub_but {\n  background: #004aad;\n  border: 0px;\n  padding: 10px 40px;\n  color: #fff;\n  font-size: 16px;\n  font-weight: 600;\n}\n\n.popuptext h3 {\n  font-size: 22px;\n  text-align: center;\n  margin-bottom: 25px;\n}\n.popuptext p {\n  font-size: 16px;\n  color: #000;\n  font-weight: 400;\n  line-height: 24px;\n}\n\n.close_button {\n  position: absolute;\n  width: 30px;\n  height: 30px;\n  background: #f00;\n  border-radius: 100%;\n  right: -10px;\n  top: -20px;\n}\n.close_button:after {\n  content: \"X\";\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  color: #fff;\n  transform: translate(-50%, -50%);\n}\n\n.modal_t_field {\n  height: 45px;\n  border-color: #004aad;\n}\n\n.modal_t_area {\n  border-color: #004aad;\n}\n\n.modal_submit {\n  text-align: center;\n}\n.modal_submit .sub_but {\n  background: #004aad;\n  border: 0px;\n  padding: 10px 40px;\n  color: #fff;\n  font-size: 16px;\n  font-weight: 600;\n}\n\n.modal_t_field1 {\n  height: 45px;\n  border-color: #004aad;\n}\n\n.ps-menuitem-root\n  .ps-submenu-root.ps-menuitem-root\n  .ps-submenu-expand-icon\n  span:after {\n  content: \"+\";\n  position: absolute;\n  right: 0;\n  font-size: 24px;\n  color: #fff;\n  top: -13px;\n  transform: none;\n}\n\n.ps-menuitem-root\n  .ps-submenu-root.ps-menuitem-root\n  .ps-menu-button.ps-open\n  .ps-submenu-expand-icon\n  span:after {\n  content: \"-\";\n  font-size: 34px;\n  top: -26px;\n}\n\n@media screen and (max-width: 1199px) {\n  .main_cont .ps-sidebar-root {\n    flex: 0 0 30%;\n  }\n}\n\n@media screen and (max-width: 767px) {\n  .main_cont .ps-sidebar-root {\n    flex: 0 0 100%;\n  }\n}\n\n@media screen and (max-width: 420px) {\n  .left_panel_partts ul li a {\n    font-size: 14px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
